import clsx from "clsx";
import PropTypes from "prop-types";
import React from "react";
import BranchLink from "web/react/components/branch-link/branch-link";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import { gettext } from "web/script/modules/django-i18n";
import { getUrl } from "web/script/routing/getUrl";
import { LanguageChoicePropType } from "web/types/language";
import SubCategory from "./../main-navigation-subcategory/main-navigation-subcategory";
import styles from "./main-navigation-gender-menu.module.css";

function GenderMenu({
    currentCountry,
    currentCurrency,
    currentLanguage,
    menu,
    onCategoryClick,
    onCountrySelectorClick,
    onLanguageSelectorClick,
    showCountryPicker,
    showLanguageSelector,
    fullRender,
    branchLinkDetails,
    onBranchLinkClick,
}) {
    const webToAppText = branchLinkDetails && gettext("app_download_small_banner.general.title");

    return (
        <>
            <div className={clsx(styles.genderMenu)}>
                {menu.menus &&
                    menu.menus.map((submenu) => {
                        return (
                            <button
                                key={submenu.display_name}
                                className={clsx(styles.menuItem)}
                                type="button"
                                onClick={() => {
                                    onCategoryClick(submenu);
                                }}
                            >
                                {submenu.display_name}
                                {!fullRender && (
                                    <SVGIcon className={styles.menuItemChevron} name="arrow-icon" />
                                )}
                            </button>
                        );
                    })}
                {menu.links &&
                    menu.links.map((link) => {
                        const isSaleLink = link.is_sale;
                        const isTrendingLink = link.is_trending;
                        return (
                            <a
                                key={link.text}
                                className={clsx(styles.menuItem, {
                                    [styles.saleLink]: isSaleLink,
                                    [styles.trendingLink]: isTrendingLink,
                                })}
                                href={link.url}
                            >
                                {isSaleLink && (
                                    <SVGIcon
                                        className={clsx(styles.saleTag, styles.saleLink)}
                                        name="tag"
                                    />
                                )}
                                {link.text}
                            </a>
                        );
                    })}

                {branchLinkDetails && (
                    <BranchLink
                        branchLink={branchLinkDetails.branchLink}
                        className={clsx(styles.menuItem, styles.downloadApp)}
                        title={webToAppText}
                        onClick={onBranchLinkClick}
                        eventLabel="navigation_menu"
                    >
                        <SVGIcon className={clsx(styles.downloadAppIcon)} name="lyst-app-icon" />
                        {webToAppText}
                    </BranchLink>
                )}

                {showCountryPicker && (
                    <button
                        type="button"
                        className={styles.menuItemBorderless}
                        onClick={onCountrySelectorClick}
                    >
                        {gettext("burger_menu.country_selector", {
                            country: currentCountry,
                            currency_indicator: currentCurrency,
                        })}
                    </button>
                )}

                {showLanguageSelector && (
                    <button
                        type="button"
                        className={styles.menuItemBorderless}
                        onClick={onLanguageSelectorClick}
                    >
                        {gettext("burger_menu.language_selector", {
                            language: currentLanguage.language_name,
                        })}
                        <SVGIcon className={styles.menuItemChevron} name="arrow-icon" />
                    </button>
                )}

                <a className={styles.menuItemBorderless} href={getUrl("helpCentreHomepage")}>
                    {gettext("header.help.help_center")}
                </a>
                <a className={styles.menuItemBorderless} href={getUrl("helpContactUs")}>
                    {gettext("header.help.contact_us")}
                </a>
                <a className={styles.menuItemBorderless} href={getUrl("about")}>
                    {gettext("header.help.about_us")}
                </a>
                <a className={styles.menuItemBorderless} href={getUrl("careers")}>
                    {gettext("header.help.careers")}
                </a>
            </div>

            {menu.menus &&
                menu.menus.map((submenu) => (
                    <SubCategory
                        key={submenu.display_name}
                        title={submenu.display_name}
                        submenu={submenu}
                        fullRender={fullRender}
                    />
                ))}
        </>
    );
}

GenderMenu.defaultProps = {
    currentCountry: "",
    currentCurrency: "",
    menu: [],
    showCountryPicker: false,
    showLanguageSelector: false,
    fullRender: false,
};

GenderMenu.propTypes = {
    menu: PropTypes.object,
    currentCountry: PropTypes.string,
    currentCurrency: PropTypes.string,
    currentLanguage: LanguageChoicePropType,
    onCategoryClick: PropTypes.func.isRequired,
    onCountrySelectorClick: PropTypes.func.isRequired,
    onLanguageSelectorClick: PropTypes.func.isRequired,
    showCountryPicker: PropTypes.bool,
    showLanguageSelector: PropTypes.bool,
    fullRender: PropTypes.bool,
    branchLinkDetails: PropTypes.object,
    onBranchLinkClick: PropTypes.func,
};

export default GenderMenu;
